// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__7sXpV","left":"StickyBox_left__1byUw","right":"StickyBox_right__1fr4U"};